// extracted by mini-css-extract-plugin
module.exports = {"InputLabel":"style_InputLabel__1vt0g","description":"style_description__2nw8g","mark":"style_mark__O-dWO","height":"style_height__XsN-I"};